import {analyticsLogEvent} from '../api'

const eventName = 'loadMore'
const eventCategory = 'Load More'

export function analyticsEventLoadMore() {
    const eventDetails = {
        eventCategory: eventCategory,
    }

    analyticsLogEvent(eventName, eventDetails)
}
